/* Load once in the business H5 on both Android and iOS. No platform branches in callers. */
(function (w) {
  'use strict';
  function iosEquipment() { return w.webkit && w.webkit.messageHandlers && w.webkit.messageHandlers.equipment; }
  function required(value, name) {
    if (!value) throw new Error(name + ' unavailable; open this page inside the app');
    return value;
  }
  w.EelinkBridge = {
    supports: function (name) {
      if (name === 'postMessage') return !!(w.EquipmentBridge && typeof w.EquipmentBridge.postMessage === 'function' || iosEquipment() && typeof iosEquipment().postMessage === 'function');
      if (name === 'startLocation' || name === 'stopLocation') return !!(w.DispatchLocationBridge && typeof w.DispatchLocationBridge[name === 'startLocation' ? 'start' : 'stop'] === 'function');
      return !!(w.AndroidBridge && typeof w.AndroidBridge[name] === 'function');
    },
    showToast: function (message) { required(w.AndroidBridge, 'AndroidBridge').showToast(message == null ? '' : String(message)); },
    getDeviceInfo: function () { return required(w.AndroidBridge, 'AndroidBridge').getDeviceInfo(); },
    getAppVersion: function () { return required(w.AndroidBridge, 'AndroidBridge').getAppVersion(); },
    fanhui: function () { required(w.AndroidBridge, 'AndroidBridge').fanhui(); },
    openBranchPipe: function (payload) {
      required(w.AndroidBridge, 'AndroidBridge').openBranchPipe(typeof payload === 'string' ? payload : JSON.stringify(payload));
    },
    postMessage: function (request) {
      var body = typeof request === 'string' ? JSON.parse(request) : request;
      if (!body || !/^[A-Za-z0-9_-]{1,100}$/.test(body.requestId || '') || typeof body.action !== 'string')
        throw new Error('Invalid native request');
      if (w.EquipmentBridge && typeof w.EquipmentBridge.postMessage === 'function') w.EquipmentBridge.postMessage(JSON.stringify(body));
      else required(iosEquipment(), 'equipment').postMessage(body);
    },
    startLocation: function () { required(w.DispatchLocationBridge, 'DispatchLocationBridge').start(); },
    stopLocation: function () { required(w.DispatchLocationBridge, 'DispatchLocationBridge').stop(); }
  };
})(window);
